<template lang="html">

        <el-form ref="form"   v-form selectAction="channel/selectChannelInfoByID.action" editAction="channel/updateChannel.action" addAction="/channel/insertChannel.action"

         :model="form" label-width="150px">
      <el-row :gutter="30">
        <el-col :span="24">

          <el-form-item label="公司名称" prop="channelName" :rules="[{ required: true, message: '公司名称不能为空'}]">
            <el-input v-model="form.channelName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="网站名称" prop="channelPageName" :rules="[{ required: true, message: '渠道页面名称不能为空'},{validator:pageNameValidator,trigger:'blur'},{ min: 4,max:10, message: '最多10个字符'},{validator:pageNameValidator,trigger:'blur'}]">
            <el-input v-model="form.channelPageName" placeholder="请输入（10字以内）"></el-input>
          </el-form-item>

          <el-form-item label="网站粉丝量（万）" prop="fansCount" :rules="[{ required: true, message: '网站粉丝数量不能为空'}]">
            <el-input v-model="form.fansCount" type="number" placeholder="请输入"></el-input>
          </el-form-item>

          <el-row>
            <el-col :span="24">
              <el-form-item label="所属地区" prop="areaName" :rules="[{ required: true, message: '所属区域不能为空'}]">
                  <search-area-input ref="business-address" v-model="form.areaName" placeholder="请选择（支持搜索联想输入）" :defaultValue="form.areaName" @onChenged="onChange"></search-area-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
                <el-form-item>
                    <el-amap ref="el-amap" vid="amap" :center="location"  class="amap" style="height:300px">
                        <el-amap-marker :position="location"></el-amap-marker>
                    </el-amap>
                </el-form-item>
            </el-col> -->
          </el-row>

          <el-form-item label="负责人姓名" prop="abutmentPersonName" :rules="[{ required: true, message: '姓名不能为空'}]">
            <el-input v-model="form.abutmentPersonName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="联系电话" prop="abutmentPhone" :rules="[{ required: true, message: '电话不能为空'},{max:11,message:'电话号码不能大于11位！'}]">
            <el-input v-model="form.abutmentPhone"  type="number" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item label="登录账户" prop="loginAccount" :rules="[{ required: true, message: '登录账户'},{max:11,message:'登录账户不能大于11位！'},{validator:validateLoginAccount,trigger:'blur'}]">
            <el-input v-model="form.loginAccount"  :disabled="(mode==='add'?true:false)" type="number" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="合作截止时间" prop="deadline" :rules="[{ required: true, message: '合作截止时间不能为空',trigger:'change'}]">
          <el-date-picker
            v-model="form.deadline"
            type="date"
            value-format="timestamp"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
<!--          <el-form-item label="分成比例" prop="privateCarShareRate" :rules="[{ required: true, message: '请输入0-100之间的整数'}]">
            <el-input v-model="form.privateCarShareRate" type="number" placeholder="请输入0-100之间的整数"></el-input>
          </el-form-item>-->
<!--        <el-form-item label="渠道资源（选填）" prop="mediaResources">
          <el-input type="textarea" v-model="form.mediaResources" placeholder="请输入渠道资源"></el-input>
          </el-form-item>-->
          <el-form-item label="维护人:" prop="maintainWorkerId" :rules="[{ required: true, message: '维护人不能为空'}]">
            <el-select v-model="form.maintainWorkerId" @change="switchMainName" >
              <el-option
                      v-for="item in maintenanceEmployees"
                      :key="item.maintenanceEmployeeSnapid"
                      :label="item.maintenanceName"
                      :value="item.maintenanceEmployeeSnapid">
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="备注（选填）" prop="remark">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入跟进渠道的最新情况"></el-input>
        </el-form-item>
        </el-col>
      </el-row>

    <el-form-item>
      <el-button  @click.native.prevent="$router.push({ name: '渠道管理'})">取消</el-button>
        <el-button type="primary">提交</el-button>
    </el-form-item>

  </el-form>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import channelModel from '@/framework/models/channelModel'
import SearchAreaInput from '@/components/SearchAreaInput'
import districtAndCountyCascader from '@/components/districtAndCountyCascader'
import BasicModel from '@/framework/basic/BasicModel'
import DateUtil from '@/framework/utils/DateUtil'
export default {
  name: 'save-channel',
  extends: BasicPager,
  data: function () {
    let priceValidator = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }

      let match = value + ''.match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        callback(new Error('小数点只能保留两位哦！'))
      } else {
        callback()
      }
    }

    let pageNameValidator = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }

      if (value.length <= 3) {
        callback(new Error('字数必须大于3个字符'))
        return
      }

      callback()

      // let match = new RegExp('^.*汽车网$').test(value)
      //
      // // let match = value+''.match(/^.*汽车网$/);
      // if(!match){
      //   callback(new Error('必须汽车网结尾'));
      // }else{
      //   callback();
      // }
    }

    let validateLoginAccount = (rule, value, callback) => {
      let _this = this
      let vl = value + ''
      let match = vl.match(/[\u4E00-\u9FA5]/)

      if (match) {
        callback(new Error('登录账号不能为汉字！'))
      }

      if (_this.oldData.loginAccount === value) {
        callback()
        return
      }

      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            callback(new Error('已存在该渠道账号，请重新输入！'))
          } else {
            callback()
          }
        }
      }
      channelModel.existsChannelAccount(this, { channelAccount: value }, listener)
    }

    return {
      priceValidator: priceValidator,
      pageNameValidator: pageNameValidator,
      validateLoginAccount: validateLoginAccount,
      location: [106.566129, 29.645191],
      maintenanceEmployees: [],
      form: {
        id: null,
        maintainWorkerId: null,
        maintainWorkerName: null,
        channelName: null,
        areaCode: null,
        areaName: null,
        bankAccountName: null,
        channelPageName: null,
        cardNumber: null,
        bankId: null,
        bankName: null,
        bankBranchName: null,
        abutmentPersonName: null,
        abutmentPhone: null,
        clueSettlement: null,
        chooseBusinesses: [],
        loginAccount: null,
        password: null,
        auxiliaryNote: null,
        fansCount: null,
        mediaResources: null,
        remark: null,
        deadline: null,
        privateCarShareRate: 50
      },
      oldData: {},
      businesses: [],
      mode: 'add',
      visible: false
    }
  },
  created: function () {
    let params = this.$route.params
    this.form.id = params.id
    if (!params.id) {
      this.mode = 'edit'
    }
    this.findMaintenceUsersList()
    let userInfo = JSON.parse(localStorage.userInfo)
    if (!params.id) {
      this.form.maintainWorkerName = userInfo.realName
      this.form.maintainWorkerId = userInfo.employeeSnapId
      this.form.deadline = DateUtil.getNDayTime(365).getTime()
    }
  },
  methods: {
    switchMainName (data) {
      let maintenanceObject = this.maintenanceEmployees.find(function (item) {
        return item.maintenanceEmployeeSnapid === data
      })

      this.form.maintainWorkerName = maintenanceObject.maintenanceName
    },
    findMaintenceUsersList () {
      let _this = this
      let params = { }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.maintenanceEmployees = dataInfo.datas
          }
        }

      }
      // 维护人列表
      BasicModel.post(_this, '/clueCar/findMaintenceUsersList.action', params, listener)
    },
    onChange: function (addressInfo) {
      let city = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county
      this.form.areaName = city
    },
    onAreaChanged: function (areaCode, areaName) {
      this.form.areaCode = areaCode[areaCode.length - 1] // 选择最后一个areaCode
      this.form.areaName = areaName.join(' ')
    },
    onFilterParams: function (params) {
      let that = this
      let loginInfo = that.getLoginInfo()

      if (params.chooseBusinesses) {
        params.businesses = JSON.stringify(this.form.chooseBusinesses)
      }
      if (params.bankAccountName) {
        params.accountName = this.form.bankAccountName
      }
      if (loginInfo && params.remark) {
        let item = {
          content: params.remark,
          createTime: new Date().getTime(),
          employeeName: loginInfo.realName
        }
        params.remark = JSON.stringify(item)
      }
    },
    onSelectInfo: function (data) {
      let dataItem = data.datas

      // 个别需要单独

      let businesses = dataItem.businesses

      if (businesses) {
        let length = businesses.length
        let businessesIds = []
        for (var i = 0; i < length; i++) {
          let business = businesses[i]

          businessesIds.push(business.id + '')
        }

        this.form.chooseBusinesses = businessesIds
      }

      // 绑定值
      // if(dataItem.areaCode){
      // this.$refs['countyCascader'].setAreaCode(dataItem.areaCode)
      // this.form.areaCode = dataItem.areaCode
      // }

      if (dataItem.remark) {
        let item = JSON.parse(dataItem.remark)
        this.form.remark = item.content
      }
      // 储存初始数据
      this.oldData = JSON.parse(JSON.stringify(this.form))
    }
  },
  components: {
    districtAndCountyCascader,
    SearchAreaInput
  }
}
</script>
